export const columns = function () {
    // 日期，机构名称，车牌号，被统筹人，单号，车辆种类，车损(统筹额度），三者(统筹额度），每座(统筹额度），统筹起期，统筹止期
    return [
        {
            prop: 'create_time',
            label: '日期',
            minWidth: 200
        },
        {
            prop: 'orgName',
            label: '机构名称',
            minWidth: 100
        },
        {
            prop: 'carNo',
            label: '车牌号',
            minWidth: 100
        },
        {
            prop: 'personName',
            label: '被统筹人',
            minWidth: 200
        },
        {
            prop: 'bh',
            label: '单号',
            minWidth: 200
        },
        {
            prop: 'carType',
            label: '车辆种类',
            minWidth: 200
        },
        {
            prop: 'carDamage',
            label: '机动车损失统筹',
            minWidth: 200
        },
        {
            prop: 'threeDamage',
            label: '第三者责任统筹',
            minWidth: 200
        },
        {
            prop: 'driverDamage',
            label: '车上人员责任统筹（司机）',
            minWidth: 200
        },
        {
            prop: 'seatDamage',
            label: '车上人员责任统筹（乘客）',
            minWidth: 200
        },
		{
		  prop: "medical_tcfee",
		  label: "医保外用药(统筹额度）",
		  minWidth: 200,
		},
		{
		  prop: "addDriverDamage",
		  label: "附加司机责任服务（身故/伤残）",
		  minWidth: 200,
		},
        {
            prop: 'beginTime',
            label: '统筹起期',
            minWidth: 200
        },
        {
            prop: 'endTime',
            label: '统筹止期',
            minWidth: 200
        }
    ]
}

export default {}